import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Field, Form, Formik } from "formik";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import "./AbhaAddressCreation.css";
import { validateValue } from "../AadharAuthentication/AadharAuthentication";
import Methods from "../../../utility/Methods";
import { useDispatch, useSelector } from "react-redux";
import { suggestionAadharThunk } from "../../Register/reducer/abhaAadhar/thunk";
import BackdropComponent from "../../../components/backdrop/index.tsx";

const AbhaAddressCreation = forwardRef(({}, ref) => {
  const [abhaId, setAbhaId] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [abhaAddressList, setAbhaAddressList] = useState([]);

  const suggestionAadhar = useSelector(
    (state) => state.abhaAddress.suggestionAadhar
  );
  const {
    status: suggestionAadharStatus,
    data: suggestionAadharData,
    error: suggestionAadharError,
  } = suggestionAadhar;
  const dispatch = useDispatch();

  const aadhaarOtp = useSelector((state) => state.abhaAddress.aadhaarOtp);
  const {
    status: aadhaarOtpStatus,
    data: aadhaarOtpData,
    error: aadhaarOtpError,
  } = aadhaarOtp;

  useEffect(() => {
    if (aadhaarOtpStatus === "succeeded") {
      let decData = JSON.parse(Methods.decryptData(aadhaarOtpData?.data));
      let finalData = decData.response;

      fetchSuggestionData(finalData?.txnId);

      // dispatch(
      //   suggestionAadharThunk({ headers: { Transaction_Id: finalData?.txnId } })
      // );
    }
  }, []);

  // useEffect(() => {
  //   if (suggestionAadharStatus === "succeeded") {
  //     console.log("enc res", suggestionAadharData);
  //     console.log(
  //       "response",
  //       JSON.parse(Methods.decryptData(suggestionAadharData?.data))
  //     );
  //     let decData = JSON.parse(Methods.decryptData(suggestionAadharData?.data));
  //     console.log("test ", decData.response);
  //     let finalData = decData.response;
  //     setAbhaAddressList(finalData.abhaAddressList);
  //   } else if (suggestionAadharStatus === "failed") {
  //     try {
  //       let decData = JSON.parse(
  //         Methods.decryptData(suggestionAadharError?.data)
  //       );
  //     } catch (e) {
  //       console.log(e, "suggestion error");
  //     }
  //     // handleShowSnackbar("error", decData?.error?.errorMessage);
  //   }
  // }, [suggestionAadharStatus]);

  const fetchSuggestionData = async (txnId) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_ABHA_BACKEND_URL + "/enrollment/enrol/suggestion",
        {
          method: "GET",
          headers: {
            Transaction_Id: txnId,
          },
        }
      );

      const result = await response.json();

      let decData = JSON.parse(Methods.decryptData(result?.data));

      let finalData = decData.response;
      setAbhaAddressList(finalData.abhaAddressList);
    } catch (error) {
      console.error("Suggestion API error:", error);

      try {
        let decData = JSON.parse(Methods.decryptData(error?.data));
        // handleShowSnackbar("error", decData?.error?.errorMessage);
      } catch (e) {
        console.log("Decryption failed:", e);
      }
    }
  };

  useEffect(() => {
    if (abhaId) {
      if (
        validateValue(
          "^(?=.{8,18}$)(?=(?:[^._]*[._]){0,2}[^._]*$)[a-zA-Z0-9._]+$",
          abhaId
        )
      )
        setIsValid(true);
      else setIsValid(false);
    } else setIsValid(false);
  }, [abhaId]);

  useImperativeHandle(ref, () => ({
    getDetails,
  }));

  const handleChangeAbhaId = (e) => {
    // console.log(
    //   validateValue("^[A-Za-z_.0-9]{0,18}$", e.target.value),
    //   e.target.value
    // );
    if (e.target.value) {
      if (validateValue("^[A-Za-z_.0-9]{0,18}$", e.target.value)) {
        setAbhaId(e.target.value);
      }
    } else setAbhaId("");
  };

  const getDetails = () => {
    if (
      validateValue(
        "^(?=.{8,18}$)(?=(?:[^._]*[._]){0,2}[^._]*$)[a-zA-Z0-9._]+$",
        abhaId
      )
    )
      return abhaId;
    else {
      setIsValid(false);
      return false;
    }
  };

  return (
    <Box>
      {suggestionAadharStatus === "pending" && <BackdropComponent />}
      <Typography className="aac_title">
        Create Your Unique ABHA Address
      </Typography>
      <Typography className="aac_content">
        ABHA (Ayushman Bharat Health Account) address is a unique username that
        allows you to share and access your health records digitally. It is
        similar to an email address, but it is only used for health records. To
        create ABHA address, it should have Min - 8 characters, Max - 18
        characters, special characters allowed - 1 dot (.) and/or 1 underscore
        (_).
      </Typography>
      <Grid container spacing={4} sx={{ marginTop: ".75rem" }}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <InputLabel className="aac_address_title" sx={{ mb: ".5rem" }}>
            Enter ABHA address
            <span style={{ color: "#f00" }}>*</span>
          </InputLabel>
          <TextField
            variant="outlined"
            size="small"
            required={true}
            value={abhaId}
            type={"text"}
            fullWidth
            onChange={handleChangeAbhaId}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{}}>
                  <IconButton
                    edge="end"
                    sx={{
                      backgroundColor: "#E9ECF3",
                      padding: ".5rem",
                      fontSize: "1rem",
                      borderRadius: "0 !important",
                      height: "-webkit-fill-available",
                    }}
                  >
                    @sbx
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={!isValid}
            helperText={
              isValid
                ? ""
                : "Must be 8-18 characters, only one dot and/or one underscore allowed"
            }
          />
        </Grid>
      </Grid>
      <Box>
        <Typography className="aac_sug_title">Suggestions:</Typography>
        {abhaAddressList.length > 0 ? (
          <Typography className="aac_sug_content">
            {abhaAddressList.join(", ")}
          </Typography>
        ) : (
          <Typography className="aac_sug_content">-</Typography>
        )}
      </Box>
    </Box>
  );
});

export default AbhaAddressCreation;

const validationSchema = Yup.object({
  abhaId: Yup.string()
    .matches(
      /^(?=.{8,18}$)(?!.*[^a-zA-Z0-9._])(?!.*\..*\..*)(?!.*_.*_.*).*/,
      "Must be 8-18 characters, only one dot and/or one underscore allowed"
    )
    .required("ABHA address is required"),
});
